<template>
  <div class="index" v-cloak>
    <div class="search-wrap">
      <van-search 
        v-model="value" 
        background="#000"
        shape="round"
        input-align="center"
        readonly
        @click="goSearch"
        placeholder="搜索你想要的优质商品" />
    </div>
    <div class="swipe-wrap">
      <van-swipe 
        class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in homeBanner" :key="item.id">
          <div class="zm_product_item">
            <router-link :to="{path: '/detail/'+ item.id}">
              <img :src="item.pic" />
            </router-link>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="category-list">
      <div 
        class="category-item" 
        v-for="(item,index) in category" 
        :key="index"
        @click="goGoodsList(item.id)"
        >
        <div class="image-wrap">
          <img :src="item.icon">
        </div>
        <div class="name">{{item.name}}</div>
      </div>
    </div>
    <div class="title-index">
      <div class="title-index-wrap">
        <div class="zh">吹风机</div>
        <div class="en">Hair Artist</div>
      </div>
    </div>
    <div class="change-wrap">
      <div 
        class="change-item-wrap" 
        :class="[item.checked ? 'on' : '']"
        v-for="(item,index) in productList" 
        :key="index"
        @click="handlerChange({listName:'productList',index})"
        >
        <div 
          class="change-item" 
          >
            {{item.name}}
        </div>
      </div>
    </div>
    <div 
      class="zm_product_item"
      v-for="(item,index) in productList"
      :key="index"
      >
      <router-link :to="{path: '/detail/'+ item.id}" v-if="item.checked">
        <img :src="item.image" />
      </router-link>
    </div>
    <router-link :to="{path:'/fitting_list?id=' + 31}" class="index-more">
      <span class="text">更多</span>
      <span class="iconfont icon-jiantou"></span>
    </router-link>
    <div class="title-index">
      <div class="title-index-wrap">
        <div class="zh">支架</div>
        <div class="en">Hair Artist</div>
      </div>
    </div>
    <div class="change-wrap">
      <div 
        class="change-item-wrap" 
        :class="[item.checked ? 'on' : '']"
        v-for="(item,index) in productList2" 
        :key="index"
        @click="handlerChange({listName:'productList2',index})"
        >
        <div 
          class="change-item" 
          >
            {{item.name}}
        </div>
      </div>
    </div>
    <div 
      class="zm_product_item"
      v-for="(item,index) in productList2"
      :key="index"
      >
      <router-link :to="{path: '/detail/'+ item.id}" v-if="item.checked">
        <img :src="item.image" />
      </router-link>
    </div>
    <router-link :to="{path:'/fitting_list?id=' + 36}" class="index-more">
      <span class="text">更多</span>
      <span class="iconfont icon-jiantou"></span>
    </router-link>
    <div class="title-index">
      <div class="title-index-wrap">
        <div class="zh">配件</div>
        <div class="en">Hair Artist</div>
      </div>
    </div>
    <div class="zm_product_item fitting">
      <router-link :to="{path: '/detail/'+92}">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/06195202207291448063187.png" />
      </router-link>
    </div>
    <div class="product-scroll">
      <div 
        class="item"
        v-for="(item,index) in productList3"
        :key="index"
        >
        <div class="img">
          <img :src="item.image">
        </div>
        <div class="title line1">{{item.store_name}}</div>
        <div class="price">
          <div class="name">活动价</div>
          <div class="num">￥{{item.price}}</div>
        </div>
        <router-link :to="{path: '/detail/'+ item.id}" class="btn">去购买</router-link>
      </div>
    </div>
    <router-link :to="{path:'/fitting_list?id=' + 37}" class="index-more fitting-more">
      <span class="text">更多</span>
      <span class="iconfont icon-jiantou"></span>
    </router-link>
    <div class="advertise">
      <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/b5822202207291528027672.png">
    </div>
    <div class="bottom-safe"></div>
    <div class="safe-padding"></div>
    <div class="zm_product">
      <!-- <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+80}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/9f709b4faeaa9f8fda128803624a28f.jpg" />
        </router-link>
      </div> -->
      
      <!-- <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+76}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/999a1202201051558081882.jpg" />
        </router-link>
      </div> -->

      <!-- 暂时 -->
      <!-- <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+92}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/59dda202204291153538641.jpg" />
        </router-link>
      </div>
      <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+94}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/dbedf202206160922272788.jpg" />
        </router-link>
      </div>
      <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+91}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/1e549202204210857271495.jpg" />
        </router-link>
      </div>
      <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+77}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/adec2202103050958495346.jpg" />
        </router-link>
      </div>
      <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+81}">
          <img src="https://dreameshop.oss-cn-beijing.aliyuncs.com/f85b2202109181419351524.jpg" />
        </router-link>
      </div> -->
      <!-- 暂时 -->


      <!-- <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+79}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/e2dd3202103050958503894.jpg" />
        </router-link>
      </div> -->
      <!-- <div class="zm_product_item">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/ce65e202103051007212725.jpg" />
      </div>
      <div class="zm_product_item">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/1cee5202103050958494588.jpg" />
      </div>
      <div class="zm_product_item">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/00ef1202103050958492574.jpg" />
      </div>
      <div class="zm_product_item">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/62031202103051008108963.jpg" />
      </div>
      <div class="zm_product_item">
        <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/f12be20210305095849918.jpg" />
      </div>
      <div class="zm_product_item">
        <router-link :to="{path: '/detail/'+76}">
          <img src="http://dreameshop.oss-cn-beijing.aliyuncs.com/15ea3202103050958495070.jpg" />
        </router-link>
      </div> -->
    </div>
    <!-- <div style="height:0.9rem;"></div> -->
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import "@assets/css/swiper.min.css";
import { getHomeData, getShare, follow , getHomeBanner} from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation, wechatEvevt } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
import { getProductDetail , getProducts} from "@api/store";
import Search from 'vant/lib/search'
import 'vant/lib/search/style'
import Swipe  from 'vant/lib/swipe'
import 'vant/lib/swipe/style'
import SwipeItem from 'vant/lib/swipe-item'
import 'vant/lib/swipe-item/style'
import { getUserInfo } from "@api/user";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  props: {},
  data: function() {
    return {
      aaa: [1,2,3,4],
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      mapKey: "",
      productid: '',
      storeInfo: {},
      // 20220729
      category:[ //分类
        {
          id:31,
          name:'吹风机',
          icon:require('@assets/images/icon_cfj.png'),
        },
        {
          id:36,
          name:'支架',
          icon:require('@assets/images/icon_zj.png'),
        },
        {
          id:37,
          name:'配件',
          icon:require('@assets/images/icon_pj.png'),
        },
      ],
      productList:[ //吹风机
        {
          id:80,
          name:'牛津绿',
          image:'http://dreameshop.oss-cn-beijing.aliyuncs.com/9f709b4faeaa9f8fda128803624a28f.jpg',
          checked:false
        },
        {
          id:95,
          name:'家庭版',
          image:'http://dreameshop.oss-cn-beijing.aliyuncs.com/dc94020220922103054254.png',
          checked:true
        }
      ],
      productList2:[
        {
          id:81,
          name:'支架',
          image:'https://dreameshop.oss-cn-beijing.aliyuncs.com/f85b2202109181419351524.jpg',
          checked:true
        },
        {
          id:77,
          name:'立架',
          image:'http://dreameshop.oss-cn-beijing.aliyuncs.com/adec2202103050958495346.jpg',
          checked:false
        },
      ],
      productList3:[],  //配件
      homeBanner:[],  //首页banner
    };
  },
  components:{
    [Search.name]:Search,
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem
  },
  created() {
    vm = this;
  },
  mounted: function() {
    let that = this;
    that.getProducts()
    that.getHomeBanner()
    getHomeData().then(res => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set( that, "lovely", res.data.lovely.length ? res.data.lovely[0] : {} );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
            // 2020.10.28  分享追加
      let productid = res.data.likeInfo[res.data.likeInfo.length-1].id
      getProductDetail(productid).then(res =>{
        that.$set(that, "storeInfo", res.data.storeInfo);
        that.setOpenShare();
      });
    });
  },
  methods: {
    /**
     * 获取首页banner
     */
    getHomeBanner(){
      getHomeBanner().then(res => {
        this.homeBanner = res.data
      }).catch(err => {
        this.$dialog.error(err.msg)
      })
    },
    /**
     * 跳转商品列表
     */
    goGoodsList(id){
      this.$router.push({
        path:'/fitting_list',
        query:{
          id
        }
      })
    },
    /**
     * 跳转搜索
     */
    goSearch(){
      console.log('000')
      this.$router.push({
        path:'/search'
      })
    },
    /**
     * 获取配件商品
     */
    getProducts(){
      let params = {
        page:1,
        limit:8,
        keyword:'',
        sid:37,
        news:0,
        priceOrder:'',
        salesOrder:''
      }
      getProducts(params).then(res => {
        this.productList3 = res.data
      }).catch(err => {
        this.$dialog.error(err.msg);
      })
    },
    /**
     * 切换产品
     * @param {String} listName 列表名称
     * @param {Number} index 索引
     */
    handlerChange({listName,index}){
      this[listName] = this[listName].map(i => { i.checked = false;return i })
      this[listName][index].checked = true
    },
    setOpenShare: function() {
      let href = location.href;
      getUserInfo().then(res =>{
        if (isWeixin()) {
        href =
          href.indexOf("?") === -1
            ? href + "?spread=" + res.data.uid
            : href + "&spread=" + res.data.uid;
        let configAppMessage = {
          desc: this.storeInfo.keyword,
          title: this.storeInfo.store_name,
          link: href,
          imgUrl: this.storeInfo.image
        };
        wechatEvevt(
          [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
            "onMenuShareTimeline"
          ],
          configAppMessage
        )
      }
      }).catch()
    },

  }
};
</script>
<style>
[v-cloak] {
  display: none;
}
.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}
.keep {
  text-align: center;
}
.search-wrap{
  /* padding: 0 .3rem;
  background: #000; */
}
.search-wrap .van-search{
  padding: .16rem .3rem;
}
.search-wrap .van-cell{
  line-height: 1;
}
.search-wrap .van-field__control{
  font-size: .26rem;
}
.search-wrap .van-field__control::placeholder{
  color: #303030 !important;
}
.search-wrap .van-icon-search{
  color: #303030;
}
.swipe-wrap .van-swipe__indicator.van-swipe__indicator--active{
  width: .55rem;
}
.swipe-wrap .van-swipe__indicator{
  border-radius: 4px;
  width:.15rem;
  height: .08rem;
  transition: all .3s;
}
</style>
<style scoped>
  .category-list{
    display: flex;
    justify-content: center;
    align-content: center;
    margin: .3rem 0 .5rem;
  }
  .category-list .category-item{
    margin: 0 .5rem;
  }
  .category-list .image-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    border-radius: 5px;
    background: rgb(235, 235, 235,.6);
  }
  .category-list .image-wrap img{
    width: 50%;
  }
  .category-list .name{
    font-size: .28rem;
    color: #2d313d;
    line-height: 1;
    text-align: center;
    margin-top: .16rem;
  }
  .title-index{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.11rem;
    background: url(http://dreameshop.oss-cn-beijing.aliyuncs.com/10195202207291042162257.png) center / cover no-repeat
  }
  .title-index .title-index-wrap{
    width: 100%;
    text-align: center;
    line-height: 1;
  }
  .title-index .zh{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: .46rem;
    color: #2d313d;
    font-weight: 600;
  }
  .title-index .zh::before{
    display: block;
    content: '';
    width: .22rem;
    height: .0219rem;
    background: #141315;
    margin-right: .2rem;
  }
  .title-index .zh::after{
    display: block;
    content: '';
    width: .22rem;
    height: .0219rem;
    background: #141315;
    margin-left: .2rem;
  }
  .title-index .en{
    color: rgb(20, 19, 21,.5);
    font-size: .2rem;
    margin-top: .04rem;
  }
  .change-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    height: .95rem;
    font-size: .28rem;
    line-height: 1;
    color: rgb(45, 49, 61,.4);
  }
  .change-wrap .change-item-wrap{
    position: relative;
    width: 1.7rem;
    height: 100%;
    /* padding: .1rem .33rem; */
    /* width: 2.25rem; */
  }
  .change-wrap .change-item-wrap .change-item{
    position: absolute;
    left: 50%;
    top: 50%;
    white-space: nowrap;
    border-radius: 25px;
    width: 1.2rem;
    text-align: center;
    transform: translateX(-50%) translateY(-50%);
  }
  .change-wrap .change-item-wrap::after{
    position: absolute;
    display: block;
    content: '';
    width: 1px;
    height: .3rem;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: rgb(45, 49, 61,.2);
  }
  .change-wrap .change-item-wrap:last-of-type::after{
    display: none;
  }
  /* .change-wrap .change-item-wrap.on{
    padding: 0;
  } */
  .change-wrap .change-item-wrap.on .change-item{
    padding: .1rem .15rem;
    color: rgb(45, 49, 61);
    border: 1px solid rgb(45, 49, 61);
  }
  .index-more{
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    margin: .44rem 0 .62rem;
  }
  .index-more .text{
    font-size: .26rem;
    color: #2d313d;
  }
  .index-more .iconfont{
    font-size: .26rem;
    color: #2d313d;
  }
  .fitting{
    margin-top: .2rem;
  }
  .product-scroll{
    display: flex;
    overflow-x: scroll;
    margin-top: .36rem;
  }
  .product-scroll .item{
    width: 2.6rem;
    line-height: 1;
    margin-left: .14rem;
  }
  .product-scroll .item:first-of-type{
    margin-left: .3rem;
  }
  .product-scroll .item:last-of-type{
    margin-right: .3rem;
  }
  .product-scroll .img{
    width: 2.6rem;
    height: 3rem;
  }
  .product-scroll .img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .product-scroll .title{
    font-size: .28rem;
    color: #565656;
    text-align: center;
    margin-top: .24rem;
  }
  .product-scroll .price{
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-top: .26rem;
  }
  .product-scroll .price .name{
    font-size: .18rem;
    color: #000;
    padding-bottom: 2px;
  }
  .product-scroll .price .num{
    font-size: .3rem;
    color: #000;
  }
  .product-scroll .btn{
    display: block;
    width: 95%;
    margin: 0 auto;
    height: .4rem;
    line-height: .4rem;
    background: #000;
    color: #fff;
    text-align: center;
    margin-top: .1rem;
    font-size: .24rem;
  }
  /* .fitting-more{
    margin-top: 0;
  } */
  .advertise img{
    width: 100%;
  }
  .bottom-safe{
    height: 1.2rem;
  }
</style>
